import { render, staticRenderFns } from "./orgTypePage.vue?vue&type=template&id=359a49b2&scoped=true&"
import script from "./orgTypePage.vue?vue&type=script&lang=js&"
export * from "./orgTypePage.vue?vue&type=script&lang=js&"
import style0 from "./orgTypePage.vue?vue&type=style&index=0&id=359a49b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a49b2",
  null
  
)

export default component.exports